import script from "./HoldingList.vue?vue&type=script&setup=true&lang=js"
export * from "./HoldingList.vue?vue&type=script&setup=true&lang=js"

import "./HoldingList.vue?vue&type=style&index=0&id=426ab585&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-426ab585"]])

export default __exports__